import { executeRequest, JFSRequest } from '@jfs/network'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  return response?.data
}

const getSubGroupsListReq = (groupId: string, subGroupId: string = '', tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.getSubGroupList),
    body:
      subGroupId.length > 0
        ? {
            subGroupId: subGroupId,
          }
        : {
            groupId: groupId,
          },
    method: 'POST',
    cache: false,
    config: sitConfig(tokens),
    headers: getHeaders(),
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { getSubGroupsListReq }
